'use strict';
require('../../products/CompanyProductsService.js');
function CompanyPublicationPlantCtrl($scope,
  $stateParams,
  $translate,
  $modal,
  CompanyProductsService,
  growl) {
  $scope.nonProductsAdded = [];
  var nonProdcutAddedPromise;

  CompanyProductsService.priceListQuery({companyId: $stateParams.companyId, all: true}).$promise.then(function(priceLists){
    var sortPriceLists = priceLists;
    var priceListStandard = priceLists.filter(function(cp){
      return cp.isStandard;
    });
    if(priceListStandard[0]){
      var indexStandard = priceLists.indexOf(priceListStandard[0]);
      sortPriceLists.splice(indexStandard, 1);
      sortPriceLists.unshift(priceListStandard[0]);
    }
    $scope.priceLists = sortPriceLists;
    angular.forEach($scope.plant.products, function(product){
      var copyProduct = angular.copy(product);
      product.pricelist = [];
      angular.forEach(sortPriceLists, function(priceL){
        var price = copyProduct.pricelist.filter(function(item){
          return (item.price_list_id === priceL.id || item.priceListId === priceL.id) && item.plant && item.plant.id === $scope.plant.id && !item.unitCategory;
        });
        if(price[0]){
          price[0].name = priceL.name;
          price[0].discountPercentage = priceL.discountPercentage;
          price[0].useFixedPrice = priceL.useFixedPrice;
          price[0].isStandard = priceL.isStandard;
          product.pricelist.push(price[0]);
        }else{
          product.pricelist.push({
            priceListId: priceL.id,
            name: priceL.name,
            discountPercentage: priceL.discountPercentage,
            useFixedPrice: priceL.useFixedPrice,
            isStandard: priceL.isStandard,
            useDefault: false,
            unitCategory: null,
            plant: {id: $scope.plant.id},
            price: null
          });
        }
      });
    });
  });

  $scope.modalEditPriceList = function(product){
    var modal = $modal({
      scope: $scope,
      controller: ['$scope', function($scope){
        $scope.productPriceLists = product.pricelist;
        $scope.updateProductPriceList = function(){
          var productP = product;
          productP.pricelist = $scope.productPriceLists;
          var productFilter = $scope.plant.products.filter(function(p){
            p.id === productP.id;
          });
          if(productFilter[0]){
            $scope.plant.products[$scope.plant.products.indexOf(productFilter[0])] = productP
          }
          $scope.updateProduct(productP);
          $scope.updatePlant();
        };
      }],
      templateUrl: 'partials/company/publications/modal-pricelist.html',
      show: false 
    });
    modal.$promise.then(modal.show);
  };

  $scope.calcProductPrice = function(product, priceList){
    if(priceList.isStandard){
      angular.forEach(product.pricelist, function(priceL){
        if(!priceL.isStandard){
          if(!priceL.useFixedPrice){
            if(priceL.discountPercentage){
              priceL.price = priceList.price - priceList.price*priceL.discountPercentage/100;
            }
          }else{
            priceL.price = priceList.price;
          }
        }
      });
    }
  };

  $scope.addProduct = function(product) {
    var copyProduct = angular.copy(product);
    product.avPriceCost = copyProduct.AvPriceCost;
    product.pricelist = [];
    angular.forEach($scope.priceLists, function(priceL){
      var price = copyProduct.pricelist.filter(function(item){
        return (item.price_list_id === priceL.id || item.priceListId === priceL.id) && item.plant && item.plant.id === $scope.plant.id && !item.unitCategory;
      });
      if(price[0]){
        price[0].discountPercentage = priceL.discountPercentage,
        price[0].useFixedPrice = priceL.useFixedPrice,
        price[0].isStandard = priceL.isStandard,
        product.pricelist.push(price[0]);
      }else{
        product.pricelist.push({
          priceListId: priceL.id,
          name: priceL.name,
          discountPercentage: priceL.discountPercentage,
          useFixedPrice: priceL.useFixedPrice,
          isStandard: priceL.isStandard,
          useDefault: false,
          unitCategory: null,
          plant: {id: $scope.plant.id},
          price: null
        });
      }
    });
    $scope.plant.products.push(product);
    $scope.nonProductsAdded.splice($scope.nonProductsAdded.indexOf(product), 1);
    angular.element('#filterProduct').val('');
    $scope.updatePlant();
  };

  $scope.removeProduct = function(index) {
    $scope.plant.products.splice(index, 1);
    $scope.updatePlant();
  };

  $scope.updateNonProductsAdded = function(filter, plantType) {
    var p = CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, type: 'PLANT', plant_type: plantType, limit: 10}).$promise.then(function(products) {
          return products.filter(function(item) {
            return !$scope.plant.products.some(function(product) {
              return item.id === product.id;
            });
          });
        }).then(function(nonProducts) {
          if(nonProdcutAddedPromise === p) {
            $scope.nonProductsAdded = nonProducts;
          }
        });
        nonProdcutAddedPromise = p;
  };

  $scope.updatePlant = function() {
    $scope.plant.$update({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, function(){
      $scope.addedProduct = null;
      growl.addSuccessMessage($translate.instant('plant.save-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('plant.save-failure'));
    });
  };

  $scope.updateProduct = function(product) {
    angular.forEach(product.pricelist, function(priceL){
      if(priceL.price){
        if(!priceL.priceListId){
          priceL.priceListId = priceL.price_list_id;
        }
        CompanyProductsService.updatePrice({companyId: $stateParams.companyId, productId: product.id}, priceL, function(){
          growl.addSuccessMessage($translate.instant('product.price-lists.save-success'));
        }, function(){
          growl.addErrorMessage($translate.instant('product.price-lists.save-failure'));
        });
      }
    });
    CompanyProductsService.update({companyId: $stateParams.companyId, productId: product.id}, product, function(){
      growl.addSuccessMessage($translate.instant('product.save-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('product.save-failure'));
    });
  };

  $scope.showModalProductList = function(plantType) {
    var modal = $modal({
      scope: $scope,
      controller: ['CompanyProductsService', '$scope', function(CompanyProductsService, $scope){
        var p = CompanyProductsService.query({companyId: $stateParams.companyId, type: 'PLANT', plant_type: plantType, all: true}).$promise.then(function(products) {
          return products.filter(function(item) {
            return !$scope.plant.products.some(function(product) {
              return item.id === product.id;
            });
          });
        }).then(function(nonProducts) {
          if(nonProdcutAddedPromise === p) {
            $scope.products = nonProducts;
          }
        });
        nonProdcutAddedPromise = p;

        $scope.listProducts = [];
        $scope.addProducts = function(){
          angular.forEach($scope.listProducts, function(product){
            $scope.addProduct(product);
          });
        };
      }],
      templateUrl: 'partials/company/publications/modal-product-list.html',
      show: false
    });
    modal.$promise.then(modal.show);
  };

}

angular.module('dokiv')
  .controller('CompanyPublicationPlantCtrl', ['$scope',
    '$stateParams',
    '$translate',
    '$modal',
    'CompanyProductsService',
    'growl',
    CompanyPublicationPlantCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/plant/CompanyPublicationPlantCtrl.js
// module id = 404
// module chunks = 0